import { defaultGetShouldRetryBasedOnResponse } from './defaultGetShouldRetryBasedOnResponse';

export const getShouldRetryBasedOnMaxRetries = ({
  maxRetries,
  numberOfFailedAttempts,
  response,
}: {
  maxRetries: number;
  numberOfFailedAttempts: number;
  response: Response;
}): boolean => {
  const numberOfPreviousRetries = numberOfFailedAttempts - 1;

  return numberOfPreviousRetries < maxRetries
    ? defaultGetShouldRetryBasedOnResponse({ response })
    : false;
};
